<div class="pv-radio" [class.disabled]="disabled" [class.error]="error">
	<label>
		<input
			class="radio"
			type="radio"
			[checked]="selected"
			[disabled]="disabled"
			[value]="value"
			(blur)="onTouched()"
			(change)="select()"
		/>
		<span>
			{{ label }}
			@if (help) {
				<ic-indicator class="help" [text]="help" />
			}
		</span>
	</label>
	<ng-content select=".errors" />
</div>
